export const routes = (prefix = `registration`) => [

    {
        path: `/${prefix}/visit-patient/:patientID`,
        name: `${prefix}.visit-patient.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.visit-patient.create`,
                PageDescription: "Patient Management - create visit",
            },
        },
    },
    {
        path: `/${prefix}/visit-patient/:patientID/edit/:visitID`,
        name: `${prefix}.visit-patient.edit`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.visit-patient.edit`,
                PageDescription: "Patient Management - Edit visit",
            },
        },
    },
    {
        path: `/${prefix}/print/:visitID`,
        name: `${prefix}.visit-patient.print`,
        component: () => import('./prints/Visit.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.visit-patient.print`,
                PageDescription: "Patient Management - Print visit",
            },
            print: true,
        },
    },
];